import {Mapper} from '@s-ui/domain'

export class FromDealersListJSONtoUrlVOMapper extends Mapper {
  constructor({config}) {
    super({config})
    this._config = config
    this._defaultSortBy = this._config.get('SORT_FIELDS').TITLE
    this._defaultSortOrder = this._config.get('ORDER').ASC
  }

  _getSortDirection = () => (this._sortOrder === this._defaultSortOrder ? 1 : -1)

  setParams = ({page, sortBy = this._defaultSortBy, sortOrder = this._defaultSortOrder}) => {
    this._page = page
    this._sortBy = sortBy
    this._sortOrder = sortOrder

    return this
  }

  map = () => ({
    pg: this._page,
    fi: this._sortBy,
    or: this._getSortDirection()
  })
}
